<template>
  <div id="setting-group" class="pt-3 setting-group-wrapper">
    <p class="text-danger" v-if="user.is_administrator && !Boolean(group.is_editable)">
      {{ $t("tools.settings.system_admin_info") }} - {{ group.name }}
    </p>
    <div class="setting-group-scroll" :class="{ row: isTwoColumns }">
      <div
        class="setting form-group"
        :class="isTwoColumns ? 'col-lg-5' : 'row'"
        v-for="setting in visibleItems"
        :key="setting.uuid"
      >
        <div class="col-lg-10 form-group pb-0 mb-0">
          <control-container :data="setting" @onSettingChanged="onSettingChanged"></control-container>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mb-3 setting-group-save" v-if="group && group.items && group.items.length > 0">
      <button class="btn btn-primary w-100" @click="save">{{ $t("common.save") }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ControlContainer from "@/pages/tools/settings/partials/controls/ControlContainer";
import { successMessage } from "@/helpers/common";

export default {
  name: "SettingGroup",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    hiddenCodes: {
      type: Array,
      default: () => [],
    },
    visibleCodes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      group: this.data ? this.data : {},
    };
  },
  components: {
    ControlContainer,
  },
  computed: {
    ...mapGetters({
      settings: "settings/groupSettings",
      user: "auth/user",
    }),
    visibleItems() {
      if (!this.group?.items?.length) {
        return [];
      }

      const visibleCodes = (this.visibleCodes || []).map((code) => (code || "").toUpperCase());

      if (visibleCodes.length) {
        return this.group.items.filter((item) => visibleCodes.includes((item?.code || "").toUpperCase()));
      }

      const hiddenCodes = (this.hiddenCodes || []).map((code) => (code || "").toUpperCase());

      if (!hiddenCodes.length) {
        return this.group.items;
      }

      return this.group.items.filter((item) => !hiddenCodes.includes((item?.code || "").toUpperCase()));
    },
    hasAccess() {
      return this.user && this.user.id > 0;
    },
    isTwoColumns() {
      return this.visibleItems.length > 5;
    },
  },
  methods: {
    ...mapActions({
      updateSettings: "settings/updateGroupSettings",
    }),
    validateAll() {
      return (
        this.visibleItems.filter((item) => {
          if (!(item.validate instanceof Function)) {
            return true;
          }

          return item.validate();
        }).length === this.visibleItems.length
      );
    },
    save() {
      if (this.validateAll()) {
        this.updateSettings(this.group).then((response) => {
          successMessage(this, response.message);
          if (this.group.code == "GENERAL") {
            window.location.reload();
          }
        });
      }
    },
    onSettingChanged() {},
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.group = newVal;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-group-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.setting-group-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.setting-group-save {
  flex: 0 0 auto;
}
</style>
